




































import { Component, Vue } from 'vue-property-decorator';
import ProjectsDialog from './components/projects-dialog.vue';
import AboutDialog from './components/about-dialog.vue';
import SettingsDialog from './components/settings-dialog.vue';
import SubscribeUsDialog from './components/subscribe-us-dialog.vue';
import { eventHub } from '@/libraries/event-hub';
import AuthProvider from '@/libraries/auth-provider';
import { Notification } from 'element-ui';

@Component({
  components: { ProjectsDialog, AboutDialog, SettingsDialog, SubscribeUsDialog },
})
export default class App extends Vue {
  private showProjects: boolean = false;
  private showAbout: boolean = false;
  private showSettings: boolean = false;
  private showSubscribeUs: boolean = false;
  private authProvider: AuthProvider = new AuthProvider();
  private user: any;
  private isAuthenticated: boolean = false;

  private created(): void {
    this.updateUser();
    eventHub.$on('login', this.updateUser);
  }

  private async login(): Promise<void> {
    try {
      await this.authProvider.login();
    } catch (exception) {
      if (exception && exception.error === 'unauthorized' && exception.error_description) {
        Notification.error({
          title: 'Başarısız',
          message: exception.error_description,
        });
      }
    }
  }

  private async updateUser(): Promise<void> {
    this.user = await this.authProvider.getUser();
    if (this.user) {
      this.isAuthenticated = true;
    }
  }

  private beforeDestroy(): void {
    eventHub.$off('login', this.updateUser);
  }

  get isMobile(): boolean {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
  }
}
